import { FC } from 'react';
import styled from 'styled-components';

import { StockLibraryImageResource } from '@/types/resources';

const Img = styled.img`
  width: 100%;
  display: block;
  border-radius: 4px;
`;

const ActionButton = styled.button`
  position: absolute;
  left: 6px;
  bottom: 6px;
  background: ${({ theme }) => theme.colors.white};
  border: 1px solid ${({ theme }) => theme.colors.grayscale};
  border-radius: 4px;
  height: 32px;
  width: 32px;
  border-radius: 4px;
  display: flex;
  align-items: center;
  justify-content: center;
  &:hover {
    border-color: rgba(34, 34, 34, 0.25);
  }
  transition: opacity ease-out 0.2s;
  opacity: 0;
`;

const Holder = styled.div`
  position: relative;
  &:hover {
    ${ActionButton} {
      opacity: 1;
    }
  }
`;

interface Props {
  image: StockLibraryImageResource;
  onLightboxClick: () => void;
}

const AiImage: FC<Props> = ({ image, onLightboxClick }) => {
  return (
    <Holder>
      <Img
        loading="lazy"
        src={image.versions.preview ?? image.versions.original}
      />
      <ActionButton
        onClick={(e) => {
          e.stopPropagation();
          onLightboxClick();
        }}
      >
        <svg
          width="17"
          height="18"
          viewBox="0 0 17 18"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M7.57888 14.5383C11.1335 14.5383 14.0152 11.6454 14.0152 8.07677C14.0152 4.50816 11.1335 1.61523 7.57888 1.61523C4.02421 1.61523 1.14258 4.50816 1.14258 8.07677C1.14258 11.6454 4.02421 14.5383 7.57888 14.5383Z"
            stroke="currentColor"
            strokeWidth="1.5"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M12.1309 12.646L15.8548 16.3845"
            stroke="currentColor"
            strokeWidth="1.5"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
        </svg>
      </ActionButton>
    </Holder>
  );
};

export default AiImage;
